module.exports = __webpack_public_path__ + "img/arrecredihome3v_dv_r2.ac71e1e6.webp";